import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20fantasy%20landscape%20with%20floating%20celestial%20palaces%20above%20clouds%2C%20golden%20divine%20light%20rays%2C%20majestic%20mountain%20peaks%2C%20traditional%20ink%20wash%20painting%20style%20with%20warm%20golden%20and%20cinnabar%20red%20tones%2C%20ethereal%20mystical%20atmosphere%2C%20grand%20scale%20composition&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="大爱仙尊——至高仙道，大爱无疆"
        title="大爱仙尊——至高仙道，大爱无疆"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center w-full px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 font-bold mb-4 md:mb-6 tracking-wider">
          大爱仙尊
        </h1>
        <p className="text-sm md:text-lg text-background-50/90 max-w-2xl leading-relaxed mb-2">
          至高仙道，大爱无疆
        </p>
        <p className="text-xs md:text-base text-background-50/70 max-w-xl leading-relaxed mb-8 md:mb-10">
          汇聚仙侠世界顶级修炼体系，以大爱之名踏上仙尊之路
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <Link
            to="/category/latest"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/40 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}